import React from 'react';
import { AutoComplete } from 'antd';
import Flexbox from 'flexbox-react';

const TypeInput = ({ title, selected = true, options, onChange, className, value }) => (
	<Flexbox className={className}>
		<AutoComplete
			disabled={!selected}
			dataSource={options}
			className='inputStyle'
			onChange={onChange}
			onSelect={onChange}
			placeholder={title}
		/>
	</Flexbox>
);

export default TypeInput;


// WEBPACK FOOTER //
// ./src/components/AnswerTypeInput/TypeInput.js